import { Injectable, inject } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { ICONS } from '../constants/icon.constants';

@Injectable({
    providedIn: 'root'
})
export class IconRegistryService {
    private iconRegistry = inject(MatIconRegistry);
    private sanitizer = inject(DomSanitizer);

    registerIcons(): void {
        const iconConfigs = [
            { name: ICONS.DASHBOARD, path: 'assets/icons/DashboardIcon.svg' },
            { name: ICONS.HOME, path: 'assets/icons/HomeIcon.svg' },
            { name: ICONS.USERS, path: 'assets/icons/Users.svg' },
            { name: ICONS.SEND_INSPECTION, path: 'assets/icons/SendForInspection.svg' },
            { name: ICONS.INSPECTION_REPORT, path: 'assets/icons/InspectionReport.svg' },
            { name: ICONS.ORGANIZATION, path: 'assets/icons/ManageOrg.svg' },
            { name: ICONS.AUDIT_LOGS, path: 'assets/icons/AuditUserLogs.svg' },
            { name: ICONS.DRIVER_LOGS, path: 'assets/icons/AuditDriverLogs.svg' },
            { name: ICONS.SETTINGS, path: 'assets/icons/Settings.svg' },
            { name: ICONS.LOGOUT, path: 'assets/icons/Logout.svg' },
            { name: ICONS.MAIL, path: 'assets/icons/Mail.svg' },
            { name: ICONS.LOCK, path: 'assets/icons/Lock.svg' },
            { name: ICONS.SSO_LOGIN, path: 'assets/icons/SSOLogin.svg' },
            { name: ICONS.VISIBILITY, path: 'assets/icons/visibility.svg' },
            { name: ICONS.VISIBILITY_OFF, path: 'assets/icons/visibility_off.svg' },
            { name: ICONS.ERROR_OUTLINE, path: 'assets/icons/error_outline.svg' },
            { name: ICONS.CHEVRON_LEFT, path: 'assets/icons/chevron_left.svg' },
            { name: ICONS.MENU, path: 'assets/icons/menu.svg' },
            { name: ICONS.ARROW_FORWARD, path: 'assets/icons/arrow_forward.svg' },
            { name: ICONS.BACK_ARROW, path: 'assets/icons/back_arrow.svg' },
            { name: ICONS.VALIDATE, path: 'assets/icons/Validate.svg' },
            { name: ICONS.EDIT, path: 'assets/icons/edit.svg' },
            { name: ICONS.DELETE, path: 'assets/icons/delete.svg' },
            { name: ICONS.ARCHIVE, path: 'assets/icons/archive.svg' },
            { name: ICONS.ARCHIVE_WHITE, path: 'assets/icons/Archive_white.svg' },
            { name: ICONS.USER_EDIT, path: 'assets/icons/user_edit.svg' },
            { name: ICONS.USER_GROUP, path: 'assets/icons/user_group.svg' },
            { name: ICONS.SENT, path: 'assets/icons/sent.svg' },
            { name: ICONS.IMPORT_MENU, path: 'assets/icons/import-menu.svg' },
            { name: ICONS.DOWNLOAD, path: 'assets/icons/download.svg' },
            { name: ICONS.CARRIER_MASTER, path: 'assets/icons/carrier-master.svg' },
            { name: ICONS.WARNING, path: 'assets/icons/inspection-count-warning.svg' }
        ];

        iconConfigs.forEach(icon => {
            this.iconRegistry.addSvgIcon(
                icon.name,
                this.sanitizer.bypassSecurityTrustResourceUrl(icon.path)
            );
        });

        // Register SVG Literals directly to prevent path resolving latency or XHR errors
        const literalIcons = [
          {
            name: ICONS.KEY_GREEN,
            svg: `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_3101_27864)">
<path d="M8.26339 2.5168C8.70636 2.07402 9.26003 1.75821 9.86664 1.60232C10.4733 1.44644 11.1106 1.45619 11.7121 1.63056C12.3137 1.80492 12.8575 2.13752 13.2867 2.59365C13.7159 3.04978 14.0148 3.61272 14.1524 4.22376C14.2899 4.83481 14.2609 5.47155 14.0684 6.06758C13.876 6.6636 13.5272 7.19707 13.0583 7.61233C12.5894 8.02759 12.0177 8.30942 11.4028 8.42843C10.7879 8.54743 10.1523 8.49925 9.56234 8.28892L4.3743 13.477H2.25298V11.3556H3.66719V9.94142H5.08141V8.52721H6.49562V7.113L7.44102 6.16759C7.21855 5.54362 7.17773 4.86932 7.32331 4.22306C7.46888 3.5768 7.79487 2.98513 8.26339 2.5168ZM10.7383 3.57746C10.5507 3.765 10.4454 4.01935 10.4454 4.28457C10.4454 4.54979 10.5507 4.80414 10.7383 4.99168C10.9258 5.17921 11.1802 5.28457 11.4454 5.28457C11.7106 5.28457 11.9649 5.17921 12.1525 4.99168C12.34 4.80414 12.4454 4.54979 12.4454 4.28457C12.4454 4.01935 12.34 3.765 12.1525 3.57746C11.9649 3.38993 11.7106 3.28457 11.4454 3.28457C11.1802 3.28457 10.9258 3.38993 10.7383 3.57746Z" fill="#16A34A"/>
</g>
<defs>
<clipPath id="clip0_3101_27864">
<rect width="16" height="16" fill="white"/>
</clipPath>
</defs>
</svg>`,
          },
          {
            name: ICONS.KEY_GREY,
            svg: `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_3101_27878)">
<path d="M8.26339 2.5168C8.70636 2.07402 9.26003 1.75821 9.86664 1.60232C10.4733 1.44644 11.1106 1.45619 11.7121 1.63056C12.3137 1.80492 12.8575 2.13752 13.2867 2.59365C13.7159 3.04978 14.0148 3.61272 14.1524 4.22376C14.2899 4.83481 14.2609 5.47155 14.0684 6.06758C13.876 6.6636 13.5272 7.19707 13.0583 7.61233C12.5894 8.02759 12.0177 8.30942 11.4028 8.42843C10.7879 8.54743 10.1523 8.49925 9.56234 8.28892L4.3743 13.477H2.25298V11.3556H3.66719V9.94142H5.08141V8.52721H6.49562V7.113L7.44102 6.16759C7.21855 5.54362 7.17773 4.86932 7.32331 4.22306C7.46888 3.5768 7.79487 2.98513 8.26339 2.5168ZM10.7383 3.57746C10.5507 3.765 10.4454 4.01935 10.4454 4.28457C10.4454 4.54979 10.5507 4.80414 10.7383 4.99168C10.9258 5.17921 11.1802 5.28457 11.4454 5.28457C11.7106 5.28457 11.9649 5.17921 12.1525 4.99168C12.34 4.80414 12.4454 4.54979 12.4454 4.28457C12.4454 4.01935 12.34 3.765 12.1525 3.57746C11.9649 3.38993 11.7106 3.28457 11.4454 3.28457C11.1802 3.28457 10.9258 3.38993 10.7383 3.57746Z" fill="#A5A6A5"/>
</g>
<defs>
<clipPath id="clip0_3101_27878">
<rect width="16" height="16" fill="white"/>
</clipPath>
</defs>
</svg>`,
          },
          {
            name: ICONS.KEY_RED,
            svg: `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_3167_27339)">
<path d="M8.26339 2.5168C8.70636 2.07402 9.26003 1.75821 9.86664 1.60232C10.4733 1.44644 11.1106 1.45619 11.7121 1.63056C12.3137 1.80492 12.8575 2.13752 13.2867 2.59365C13.7159 3.04978 14.0148 3.61272 14.1524 4.22376C14.2899 4.83481 14.2609 5.47155 14.0684 6.06758C13.876 6.6636 13.5272 7.19707 13.0583 7.61233C12.5894 8.02759 12.0177 8.30942 11.4028 8.42843C10.7879 8.54743 10.1523 8.49925 9.56234 8.28892L4.3743 13.477H2.25298V11.3556H3.66719V9.94142H5.08141V8.52721H6.49562V7.113L7.44102 6.16759C7.21855 5.54362 7.17773 4.86932 7.32331 4.22306C7.46888 3.5768 7.79487 2.98513 8.26339 2.5168ZM10.7383 3.57746C10.5507 3.765 10.4454 4.01935 10.4454 4.28457C10.4454 4.54979 10.5507 4.80414 10.7383 4.99168C10.9258 5.17921 11.1802 5.28457 11.4454 5.28457C11.7106 5.28457 11.9649 5.17921 12.1525 4.99168C12.34 4.80414 12.4454 4.54979 12.4454 4.28457C12.4454 4.01935 12.34 3.765 12.1525 3.57746C11.9649 3.38993 11.7106 3.28457 11.4454 3.28457C11.1802 3.28457 10.9258 3.38993 10.7383 3.57746Z" fill="#DC2626"/>
</g>
<defs>
<clipPath id="clip0_3167_27339">
<rect width="16" height="16" fill="white"/>
</clipPath>
</defs>
</svg>`,
          },
          {
            name: ICONS.MAIL_GREEN,
            svg: `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M14.6693 5.02344V11.3334C14.6693 11.8436 14.4744 12.3344 14.1244 12.7056C13.7744 13.0768 13.2959 13.3002 12.7866 13.3301L12.6693 13.3334H3.33594C2.8258 13.3335 2.33493 13.1386 1.96376 12.7886C1.5926 12.4386 1.3692 11.96 1.33927 11.4508L1.33594 11.3334V5.02344L7.6326 9.22144L7.70994 9.26544C7.80107 9.30997 7.90117 9.33311 8.0026 9.33311C8.10404 9.33311 8.20413 9.30997 8.29527 9.26544L8.3726 9.22144L14.6693 5.02344Z" fill="#16A34A"/>
<path d="M12.6695 2.66797C13.3895 2.66797 14.0208 3.04797 14.3728 3.6193L8.00281 7.86597L1.63281 3.6193C1.80001 3.34785 2.02967 3.1203 2.30266 2.95563C2.57565 2.79095 2.88405 2.69393 3.20215 2.67264L3.33615 2.66797H12.6695Z" fill="#16A34A"/>
</svg>`,
          },
          {
            name: ICONS.MAIL_GREY,
            svg: `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M14.6693 5.02344V11.3334C14.6693 11.8436 14.4744 12.3344 14.1244 12.7056C13.7744 13.0768 13.2959 13.3002 12.7866 13.3301L12.6693 13.3334H3.33594C2.8258 13.3335 2.33493 13.1386 1.96376 12.7886C1.5926 12.4386 1.3692 11.96 1.33927 11.4508L1.33594 11.3334V5.02344L7.6326 9.22144L7.70994 9.26544C7.80107 9.30997 7.90117 9.33311 8.0026 9.33311C8.10404 9.33311 8.20413 9.30997 8.29527 9.26544L8.3726 9.22144L14.6693 5.02344Z" fill="#A5A6A5"/>
<path d="M12.6695 2.66797C13.3895 2.66797 14.0208 3.04797 14.3728 3.6193L8.00281 7.86597L1.63281 3.6193C1.80001 3.34785 2.02967 3.1203 2.30266 2.95563C2.57565 2.79095 2.88405 2.69393 3.20215 2.67264L3.33615 2.66797H12.6695Z" fill="#A5A6A5"/>
</svg>`,
          },
          {
            name: ICONS.MAIL_RED,
            svg: `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M14.6693 5.02344V11.3334C14.6693 11.8436 14.4744 12.3344 14.1244 12.7056C13.7744 13.0768 13.2959 13.3002 12.7866 13.3301L12.6693 13.3334H3.33594C2.8258 13.3335 2.33493 13.1386 1.96376 12.7886C1.5926 12.4386 1.3692 11.96 1.33927 11.4508L1.33594 11.3334V5.02344L7.6326 9.22144L7.70994 9.26544C7.80107 9.30997 7.90117 9.33311 8.0026 9.33311C8.10404 9.33311 8.20413 9.30997 8.29527 9.26544L8.3726 9.22144L14.6693 5.02344Z" fill="#DC2626"/>
<path d="M12.6695 2.66797C13.3895 2.66797 14.0208 3.04797 14.3728 3.6193L8.00281 7.86597L1.63281 3.6193C1.80001 3.34785 2.02967 3.1203 2.30266 2.95563C2.57565 2.79095 2.88405 2.69393 3.20215 2.67264L3.33615 2.66797H12.6695Z" fill="#DC2626"/>
</svg>`,
          },
          {
            name: ICONS.EDIT_BLUE,
            svg: `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M2 11.6416V13.6683C2 13.855 2.14667 14.0016 2.33333 14.0016H4.36C4.44667 14.0016 4.53333 13.9683 4.59333 13.9016L11.8733 6.6283L9.37333 4.1283L2.1 11.4016C2.03333 11.4683 2 11.5483 2 11.6416ZM13.8067 4.69496C13.8685 4.63329 13.9175 4.56003 13.951 4.47938C13.9844 4.39873 14.0016 4.31228 14.0016 4.22496C14.0016 4.13765 13.9844 4.0512 13.951 3.97055C13.9175 3.8899 13.8685 3.81664 13.8067 3.75496L12.2467 2.19496C12.185 2.13316 12.1117 2.08413 12.0311 2.05067C11.9504 2.01722 11.864 2 11.7767 2C11.6894 2 11.6029 2.01722 11.5223 2.05067C11.4416 2.08413 11.3683 2.13316 11.3067 2.19496L10.0867 3.41496L12.5867 5.91496L13.8067 4.69496Z" fill="white"/>
</svg>`,
          },
          {
            name: ICONS.ADD_BLUE,
            svg: `<svg width="16" height="16" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <g id="Complete">
                        <g data-name="add" id="add-2">
                            <g>
                                <line fill="none" stroke="white" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" x1="12" x2="12" y1="19" y2="5"/>
                                <line fill="none" stroke="white" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" x1="5" x2="19" y1="12" y2="12"/>
                            </g>
                        </g>
                    </g>
                 </svg>`,
          },
        ];

        literalIcons.forEach(icon => {
            this.iconRegistry.addSvgIconLiteral(
                icon.name,
                this.sanitizer.bypassSecurityTrustHtml(icon.svg)
            );
        });
    }
}
